import React, { CSSProperties } from 'react';

import type { SelectProps } from '@mui/material';
import { Select } from '@mui/material';

export type LookoSelectProps<Value = unknown> = Pick<
  SelectProps<Value>,
  'children' | 'placeholder' | 'defaultValue' | 'value' | 'error' | 'disabled' | 'onChange' | 'displayEmpty'
> & {
  /**
   * Select 크기.
   *
   * @default medium
   */
  size?: 'small' | 'medium';
  multiple?: boolean;
  fontSize?: CSSProperties['fontSize'];
  width?: CSSProperties['width'];
};

/**
 * Select UI.
 *
 * TODO:
 * - helper 텍스트.
 */
export const LookoSelect = React.forwardRef<HTMLSelectElement, LookoSelectProps>(LookoSelectImpl) as <Value = unknown>(
  props: LookoSelectProps<Value> & { ref?: React.ForwardedRef<HTMLSelectElement> },
) => ReturnType<typeof LookoSelectImpl>;

function LookoSelectImpl(props: LookoSelectProps, ref?: React.ForwardedRef<HTMLSelectElement>) {
  return (
    <Select
      ref={ref}
      {...props}
      fullWidth
      sx={{
        height: props.size === 'medium' ? 40 : 32,
        width: props.width,
        //XXX: https://github.com/mui/material-ui/issues/11069 placeholder issue
        '& .MuiSelect-select .notranslate::after': props.placeholder
          ? {
              content: `"${props.placeholder}"`,
              color: 'text.disabled',
              fontSize: props.fontSize ?? 14,
            }
          : {},
        '& .MuiSelect-select .notranslate': props.placeholder
          ? {
              color: 'text.disabled',
            }
          : {},
      }}
    />
  );
}
